import withApp from 'artkive/hoc/withApp'

import Pricing from './Pricing'

export default withApp(Pricing)
